// src/components/Contact.js
import React, { useState } from "react";
import {
  Box,
  Heading,
  Text,
  Link,
  VStack,
  useColorModeValue,
  Input,
  Textarea,
  FormControl,
  FormLabel,
  IconButton,
  HStack,
  Spacer,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";
import { IoSend } from "react-icons/io5";
import { SiUpwork } from "react-icons/si";

const Contact = () => {
  const textColor = useColorModeValue("gray.800", "whiteAlpha.900");
  const bgColor = useColorModeValue("white", "gray.800");
  const buttonBg = useColorModeValue("black", "whiteAlpha.900");
  const buttonTextColor = useColorModeValue("white", "gray.800");
  const buttonHoverBg = useColorModeValue("gray.700", "white");

  // State for the message input
  const [message, setMessage] = useState("");

  // Function to handle the Send Message button click
  const handleSendMessage = () => {
    if (message.trim() === "") {
      alert("Please enter a message before sending.");
      return;
    }
    const mailtoLink = `mailto:moabubakar230@gmail.com?subject=Contact from Portfolio&body=${encodeURIComponent(
      message
    )}`;
    window.location.href = mailtoLink;
  };

  return (
    <Box
      p={{ base: 4, md: 8 }}
      bg={bgColor}
      color={textColor}
      position="relative"
      minH="100vh"
    >
      <VStack align="stretch">
        <Heading
          size={{ base: "lg", md: "xl" }}
          textAlign={{ base: "center", md: "left" }}
        >
          Get in Touch
        </Heading>
        <Text
          fontSize={{ base: "sm", md: "md" }}
          textAlign={{ base: "center", md: "left" }}
        >
          I'm always open to discussing new projects, creative ideas, or
          opportunities to be part of your vision. Feel free to reach out
          through any of the methods below.
        </Text>

        <FormControl id="email" isReadOnly>
          <FormLabel>To:</FormLabel>
          <Input value="moabubakar230@gmail.com" isReadOnly />
        </FormControl>

        <FormControl id="message" my={"4"}>
          <FormLabel>Write a Message</FormLabel>
          <Box position="relative">
            <Textarea
              placeholder="Your message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              size="md"
              pr="60px" // Padding to prevent text overlap with the send button
              height="200px"
            />
            <IconButton
              icon={<IoSend />}
              aria-label="Send Message"
              position="absolute"
              bottom="10px"
              right="10px"
              bg={buttonBg}
              color={buttonTextColor}
              _hover={{ bg: buttonHoverBg }}
              onClick={handleSendMessage}
            />
          </Box>
        </FormControl>

        {/* Spacer to push the connect section to the bottom */}
        <Spacer />

        {/* Connect Through Section */}
        <Box>
          <Text fontSize={{ base: "md", md: "lg" }} mb={2}>
            Connect through:
          </Text>
          <HStack spacing={4}>
            {/* LinkedIn IconButton */}
            <IconButton
              as={Link}
              href="https://www.linkedin.com/in/mohammad-abubakar-099aa122a/"
              aria-label="LinkedIn"
              icon={<FaLinkedin />}
              size="lg"
              bg={buttonBg}
              color={buttonTextColor}
              _hover={{ bg: buttonHoverBg }}
              isExternal
            />
            {/* Upwork IconButton */}
            <IconButton
              as={Link}
              href="https://www.upwork.com/freelancers/~01dae55f269b1bfec4"
              aria-label="Upwork"
              icon={<SiUpwork />}
              size="lg"
              bg={buttonBg}
              color={buttonTextColor}
              _hover={{ bg: buttonHoverBg }}
              isExternal
            />
          </HStack>
        </Box>
      </VStack>
    </Box>
  );
};

export default Contact;
